<template>
  <v-layout align-start>
    <v-flex>
      <v-toolbar flat color="white">
        <v-toolbar-title>Ventas</v-toolbar-title>
        <v-divider class="mx-2" inset vertical></v-divider>
        <v-spacer></v-spacer>
        <v-text-field
          v-if="verNuevo == 0"
          class="text-xs-center"
          v-model="search"
          append-icon="search"
          label="Búsqueda"
          single-line
          hide-details
        ></v-text-field>
        <v-btn
          v-if="verNuevo == 0"
          @click="listar()"
          color="primary"
          dark
          class="mb-2"
          >Buscar</v-btn
        >
        <v-spacer></v-spacer>
        <v-btn
          v-if="verNuevo == 0"
          @click="mostrarNuevo"
          color="primary"
          dark
          class="mb-2"
          >Nuevo</v-btn
        >
        <v-dialog
          v-model="verArticulos"
          max-width="1000px"
          transition="dialog-bottom-transition"
        >
          <v-card>
            <v-card-title>
              <span class="headline">Seleccione un artículo</span>
            </v-card-title>
            <v-card-text>
              <v-container grid-list-md>
                <v-layout wrap>
                  <v-flex xs12 sm12 md12 lg12 xl12>
                    <v-text-field
                      append-icon="search"
                      class="text-xs-center"
                      v-model="texto"
                      label="Ingrese el nombre del artículo a buscar"
                      @keyup="listarArticulo()"
                    >
                    </v-text-field>
                    <template>
                      <v-data-table
                        :headers="cabeceraArticulos"
                        :items="articulos"
                        class="elevation-1"
                      >
                        <template slot="items" slot-scope="props">
                          <td class="justify-center layout px-0">
                            <v-icon
                              small
                              class="mr-2"
                              @click="agregarDetalle(props.item)"
                            >
                              add
                            </v-icon>
                          </td>
                          <td>{{ props.item.nombre }}</td>
                          <td>{{ props.item.categoria }}</td>
                          <td>{{ props.item.descripcion }}</td>
                          <td>{{ props.item.stock }}</td>
                          <td>{{ props.item.precio_venta }}</td>
                        </template>
                        <template slot="no-data">
                          <h3>No hay artículos para mostrar.</h3>
                        </template>
                      </v-data-table>
                    </template>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn @click="ocultarArticulos()" color="blue darken" flat>
                Cancelar
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-dialog v-model="adModal" max-width="290">
          <v-card>
            <v-card-title class="headline" v-if="adAccion == 1"
              >¿Activar Item?</v-card-title
            >
            <v-card-title class="headline" v-if="adAccion == 2"
              >¿Anular Venta?</v-card-title
            >
            <v-card-text>
              Estás a punto de
              <span v-if="adAccion == 1">Activar </span>
              <span v-if="adAccion == 2">Anular </span>
              el ítem {{ adNombre }}
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="green darken-1"
                flat="flat"
                @click="activarDesactivarCerrar"
              >
                Cancelar
              </v-btn>
              <v-btn
                v-if="adAccion == 1"
                color="orange darken-4"
                flat="flat"
                @click="activar"
              >
                Activar
              </v-btn>
              <v-btn
                v-if="adAccion == 2"
                color="orange darken-4"
                flat="flat"
                @click="desactivar"
              >
                Anular
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-dialog v-model="comprobanteModal" max-width="900px">
  <v-card>
    <v-card-text>
      <v-btn @click="imprimir()">
        <v-icon>print</v-icon>
      </v-btn>
      <!-- <v-btn @click="crearPDF()">
        <v-icon>description</v-icon>
      </v-btn> -->

      <!-- Vista previa (ticket-preview) -->
      <div v-if="isPreview" id="ticket-preview" class="ticket-preview">
        <div id="logo">
          <img id="imagen" src="@/assets/variedades-aby-logo.jpg" alt="Variedades Aby" />
        </div>

        <div class="detalles">
          <h5>NO. {{ num_factura }}</h5>
          <h5>FACTURA: {{ tipo_comprobante }}</h5>
          <h5>FECHA: {{ fecha_hora | moment("DD/MM/YYYY") }} | {{ fecha_hora | moment("LT") }}</h5>
        </div>

        <hr />

        <div class="cliente">
          <h5>Sr(a): {{ cliente }}</h5>
          <h5>Documento: {{ num_documento }}</h5>
          <h5>Dirección: {{ direccion }}</h5>
          <h5>Teléfono: {{ telefono }}</h5>
          <h5>Email: {{ email }}</h5>
        </div>

        <hr />

        <table class="factura-tabla">
          <thead>
            <tr>
              <th>Cantidad</th>
              <th>Producto</th>
              <th>Precio</th>
              <th>Descuento</th>
              <th>Total</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="det in detalles" :key="det.iddetalle_venta">
              <td>{{ det.cantidad }}</td>
              <td>{{ det.articulo }}</td>
              <td>{{ det.precio.toFixed(2) }}</td>
              <td>{{ det.descuento }}</td>
              <td>{{ (det.cantidad * det.precio - det.descuento).toFixed(2) }}</td>
            </tr>
          </tbody>
        </table>

        <hr />

        <div class="totales">
          <div>SUBTOTAL: {{ calcularTotal.toFixed(2) | currency }}</div>
          <div>DESCUENTO: {{ calcularDescuento | currency }}</div>
          <div>ENVÍO: {{ impuesto | currency }}</div>
          <div>
          TOTAL: {{ ((parseFloat(calcularTotal) || 0) - (parseFloat(calcularDescuento) || 0) + (parseFloat(impuesto) || 0)).toFixed(2) | currency }}
</div>


        </div>

        <div class="agradecimiento">
          <strong>¡GRACIAS POR SU COMPRA!</strong>
        </div>
      </div>

      <!-- Contenido a imprimir (ticket) -->
      <div v-if="!isPreview" id="ticket">
        <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/materialize/1.0.0-beta/css/materialize.min.css" media="print" />
        <div id="logo">
          <img style="text-align: center; margin-top: 0px; margin-bottom: 0px;" id="imagen" src="@/assets/logo-print2.jpg" alt="Aby" />
        </div>

        <div>
          <h5 style="font-weight: bold; font-size: 25px">NO. {{ num_factura }}</h5>
          <h5 style="font-weight: bold; font-size: 25px">FACTURA: {{ tipo_comprobante }}</h5>
          <h5 style="font-weight: bold; font-size: 25px">FECHA: {{ fecha_hora | moment("DD/MM/YYYY") }} | {{ fecha_hora | moment("LT") }}</h5>
          <div style="font-weight: bold; font-size: 25px" class="okas">-------------------------------------------------</div>
        </div>

        <br />

        <div>
          <div class="flow-text">
            <h5 style="font-weight: bold; font-size: 20px">Sr(a): {{ cliente }}</h5>
            <h5 style="font-weight: bold; font-size: 20px">Documento: {{ num_documento }}</h5>
            <h5 style="font-weight: bold; font-size: 20px">Dirección: {{ direccion }}</h5>
            <h5 style="font-weight: bold; font-size: 20px">Telefono: {{ telefono }}</h5>
            <h5 style="font-weight: bold; font-size: 20px">Email: {{ email }}</h5>
          </div>
        </div>

        <div class="okas">-----------------------------------------------------------------------------------</div>

        <table>
  <!-- Encabezados de la tabla (solo aparecen en la primera página) -->
  <tr>
    <th>Cantidad</th>
    <th>Producto</th>
    <th>Precio</th>
    <!-- <th>Descuento</th> -->
    <th>Total</th>
  </tr>

  <!-- Cuerpo de la tabla -->
  <tbody>
    <tr v-for="det in detalles" :key="det.iddetalle_venta">
      <td>{{ det.cantidad }}</td>
      <td>{{ det.articulo }}</td>
      <td>{{ det.precio.toFixed(2) }}</td>
      <!-- <td>{{ det.descuento }}</td> -->
      <td>{{ (det.cantidad * det.precio).toFixed(2) }}</td>
    </tr>
  </tbody>

  <!-- Pie de la tabla que solo debe aparecer al final de la última página -->
  <tfoot>
    <tr>
      <td colspan="2"></td>
      <td>Subtotal:</td>
      <td>{{ calcularTotal.toFixed(2) }}</td>
    </tr>
    <tr>
      <td colspan="2"></td>
      <td>Descuento:</td>
      <td>{{ calcularDescuento.toFixed(2) }}</td>
    </tr>
    <tr>
      <td colspan="2"></td>
      <td>Envío:</td>
      <td>{{ impuesto.toFixed(2) }}</td>
    </tr>
    <tr>
      <td colspan="2"></td>
      <td>Total C$:</td>
      <td>{{ (calcularTotal.toFixed(2) - calcularDescuento + impuesto).toFixed(2) }}</td>
    </tr>
  </tfoot>
</table>






        <br />
        <strong style="font-weight: bold; font-size: 20px">Atendido por: {{ vendedor }}</strong><br /><br />
        <div class="div" style="text-align: center">
          <strong style="font-weight: bold; font-size: 30px" class="text-bold centrado">¡GRACIAS POR SU COMPRA!</strong>
        </div>
      </div>

      <v-btn @click="ocultarComprobante" color="blue darken-1" flat>Cancelar</v-btn>
    </v-card-text>
  </v-card>
</v-dialog>

    
 <!-- <v-dialog v-model="comprobanteModal" max-width="900px">
  <v-card>
    <v-card-title class="text-h5">Vista previa de factura</v-card-title>
    <v-card-text>
      <v-btn @click="imprimir">
        <v-icon>mdi-printer</v-icon> Imprimir
      </v-btn>
      
      <div id="ticket-preview" class="ticket-preview">
        <div id="logo">
          <img
            id="imagen"
            src="@/assets/variedades-aby-logo.jpg"
            alt="Variedades Aby"
          />
        </div>

        <div class="detalles">
          <h5>NO. {{ num_factura }}</h5>
          <h5>FACTURA: {{ tipo_comprobante }}</h5>
          <h5>FECHA: {{ fecha_hora | moment("DD/MM/YYYY") }} | {{ fecha_hora | moment("LT") }}</h5>
        </div>

        <hr />

        <div class="cliente">
          <h5>Sr(a): {{ cliente }}</h5>
          <h5>Documento: {{ num_documento }}</h5>
          <h5>Dirección: {{ direccion }}</h5>
          <h5>Teléfono: {{ telefono }}</h5>
          <h5>Email: {{ email }}</h5>
        </div>

        <hr />

        <table class="factura-tabla">
          <thead>
            <tr>
              <th>Cantidad</th>
              <th>Producto</th>
              <th>Precio</th>
              <th>Descuento</th>
              <th>Total</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="det in detalles" :key="det.iddetalle_venta">
              <td>{{ det.cantidad }}</td>
              <td>{{ det.articulo }}</td>
              <td>{{ det.precio.toFixed(2) }}</td>
              <td>{{ det.descuento }}</td>
              <td>{{ (det.cantidad * det.precio - det.descuento).toFixed(2) }}</td>
            </tr>
          </tbody>
        </table>

        <hr />

        <div class="totales">
          <div>SUBTOTAL: {{ calcularTotal.toFixed(2) | currency }}</div>
          <div>DESCUENTO: {{ calcularDescuento | currency }}</div>
          <div>ENVÍO: {{ impuesto | currency }}</div>
          <div>TOTAL: {{ (calcularTotal - calcularDescuento + impuesto).toFixed(2) | currency }}</div>
        </div>

        <div class="agradecimiento">
          <strong>¡GRACIAS POR SU COMPRA!</strong>
        </div>
      </div>
    </v-card-text>
    <v-card-actions>
      <v-btn color="blue darken-1" text @click="ocultarComprobante">Cerrar</v-btn>
    </v-card-actions>
  </v-card>
</v-dialog> -->

      </v-toolbar>
      <v-data-table
        :headers="headers"
        :items="ventas"
        :search="search"
        :custom-sort="customSort"
        class="elevation-1"
        v-if="verNuevo == 0"
      >
        <template slot="items" slot-scope="props">
          <td class="justify-center layout px-0">
            <v-icon small class="mr-2" @click="verDetalles(props.item)">
              tab
            </v-icon>
            <v-icon small class="mr-2" @click="mostrarComprobante(props.item)">
              print
            </v-icon>
            <!--       <template v-if="props.item.estado!= 'Anulado' ">
              <v-icon small @click="activarDesactivarMostrar(2, props.item)">
                block
              </v-icon>
            </template> -->
          </td>
          <td>{{ props.item.sucursal }}</td>
          <td>{{ props.item.codigoFactura }}</td>
          <td>{{ props.item.usuario }}</td>
          <td>{{ props.item.cliente }}</td>
          <td>{{ props.item.tipo_comprobante }}</td>
          <td>{{ props.item.fecha_hora | moment("DD/MM/YYYY") }}</td>
          <!-- <td>{{ props.item.tipoenvio }}</td> -->
          <td>
            <div class="text-center">
              <span v-if="props.item.tipoenvio == 'CARGOTRANS'">
                <v-chip
                  class="ma-2"
                  color="deep-orange darken-3"
                  label
                  text-color="white"
                >
                  <v-icon left> local_shipping </v-icon>
                  {{ props.item.tipoenvio }}
                </v-chip>
              </span>
              <span v-if="props.item.tipoenvio == 'MOTORIZADO'">
                <v-chip
                  class="ma-2"
                  color="deep-purple darken-1"
                  label
                  text-color="white"
                >
                  <v-icon left> two_wheeler </v-icon>
                  {{ props.item.tipoenvio }}
                </v-chip>
              </span>
              <span v-if="props.item.tipoenvio == ''">
              <v-chip
                class="ma-2"
                color="grey darken-1"
                label
                text-color="white"
              >
                <v-icon left>remove_circle_outline</v-icon>
                Sin envío
              </v-chip>
         </span>
            </div>
          </td>
          <td>{{ props.item.impuesto | currency }}</td>
          <td>{{ props.item.total | currency }}</td>

          <td>
            <div class="text-center">
              <span v-if="props.item.estado == 'Aceptado'">
                <v-chip class="ma-2" color="cyan" label text-color="white">
                  <v-icon left> check_circle </v-icon>
                  {{ props.item.estado }}
                </v-chip>
              </span>
              <span v-if="props.item.estado == 'CANCELADO'">
                <v-chip class="ma-2" color="cyan" label text-color="white">
                  <v-icon left> check_circle </v-icon>
                  {{ props.item.estado }}
                </v-chip>
              </span>
              <span v-if="props.item.estado == 'PENDIENTE'">
                <v-chip
                  class="ma-2"
                  color="yellow darken-3"
                  label
                  text-color="white"
                >
                  <v-icon left> hourglass_top </v-icon>
                  {{ props.item.estado }}
                </v-chip>
              </span>

              <span v-if="props.item.estado == 'Anulado'">
                <v-chip
                  class="ma-2"
                  color="red accent-4"
                  label
                  text-color="white"
                >
                  <v-icon left> highlight_off </v-icon>
                  {{ props.item.estado }}
                </v-chip>
              </span>
            </div>
          </td>
        </template>
        <template slot="no-data">
          <v-btn color="primary" @click="listar">Resetear</v-btn>
        </template>
      </v-data-table>
      <v-container grid-list-sm class="pa-4 white" v-if="verNuevo">
        <v-layout row wrap>
          <v-flex xs12 sm5 md5 lg5 xl5>
            <v-select
              v-model="tipocomprobante"
              :items="comprobantes"
              label="Tipo Factura"
            >
            </v-select>
          </v-flex>
          <v-spacer></v-spacer>
          <v-flex xs12 sm6 md6 lg6 xl6>
            <v-select
              :readonly="cambiarBodega"
              v-model="idbodega"
              :items="bodegas"
              label="Bodega"
            >
            </v-select>
          </v-flex>

          <v-flex xs12 sm5 md5 lg5 xl5>
            <v-select
              v-model="userId"
              :items="vendedores"
              label="Vendedor"
              
            >
            </v-select>
          </v-flex>

          <v-spacer></v-spacer>
          <v-flex xs12 sm6 md6 lg6 xl6>
            <v-select
              v-model="customer"
              :items="clientes"
              @change="clienteGenerico($event)"
              label="Clientes"
              autocomplete="on"
            >
            </v-select>
          </v-flex>

          <v-flex v-if="flag" xs12 sm4 md4 lg4 xl4>
            <v-text-field
              type="text"
              v-model="nombrecliente"
              label="Nombre Cliente"
            >
            </v-text-field>
          </v-flex>

          <v-flex v-if="flag" xs12 sm4 md4 lg4 xl4>
            <v-text-field
              type="text"
              v-model="departamento"
              label="Departamento"
            >
            </v-text-field>
          </v-flex>

          <v-flex v-if="flag" xs12 sm4 md4 lg4 xl4>
            <v-text-field type="number" v-model="telefono" label="Telefono">
            </v-text-field>
          </v-flex>

          <br />
          <v-flex xs12 sm6 md6 lg6 xl6>
            <v-checkbox
              v-model="checkbox"
              @change="validarCheck()"
              :label="`Envio`"
            ></v-checkbox>
          </v-flex>

          <v-flex v-if="checkbox" xs12 ssm6 md6 lg6 xl6>
            <v-text-field type="number" v-model="impuesto" label="Envio">
            </v-text-field>
          </v-flex>
          <v-flex v-if="checkbox" xs12 sm5 md5 lg5 xl5>
            <v-select v-model="tipo_envio" :items="envios" label="Tipo envio">
            </v-select>
          </v-flex>
          <v-spacer></v-spacer>
          <v-flex xs12 sm6 md6 lg6 xl6>
            <v-text-field
              type="number"
              v-model="tasacambio"
              label="Tasa de cambio"
              
            >
            </v-text-field>
          </v-flex>
          <v-flex v-if="esContado" xs12 sm4 md4 lg4 xl4>
            <v-select
              v-model="tipoPago"
              :items="tipoPagos"
              label="Tipo Pago"
            >
            </v-select>
          </v-flex>
          <v-flex v-if="esContado" xs12 sm2 md2 lg2 xl2>
            
          </v-flex>
          <v-flex  xs12 sm6 md6 lg6 xl6 v-if="esContado && tipoPago==='TRANSFERENCIA'">
            <v-text-field
              v-model="descripcionPago"
              label="Número Referencia"
            >
            </v-text-field>
          </v-flex>
          <v-spacer></v-spacer>
          <v-flex xs12 sm9 md9 lg9 xl9>
            <v-text-field
              @keyup.enter="buscarCodigo()"
              v-model="codigo"
              label="Buscar articulo por código"
            >
            </v-text-field>
          </v-flex>
          <v-flex xs12 sm2 md2 lg2 xl2>
            <v-btn @click="mostrarArticulos()" small fab dark color="teal">
              <v-icon dark>list</v-icon>
            </v-btn>
          </v-flex>
          <v-flex xs12 sm2 md2 lg2 xl2 v-if="errorArticulo">
            <div class="red--text" v-text="errorArticulo"></div>
          </v-flex>
          <v-flex xs12 sm12 md12 lg12 xl12>
            <v-data-table
              :headers="cabeceraDetalles"
              :items="detalles"
              hide-actions
              class="elevation-1"
            >
              <template slot="items" slot-scope="props">
                <td class="justify-center layout px-0">
                  <v-icon
                    small
                    class="mr-2"
                    @click="eliminarDetalle(detalles, props.item)"
                  >
                    delete
                  </v-icon>
                </td>
                <td>{{ props.item.articulo }}</td>
                <td>
                  <v-text-field
                    type="number"
                    v-model="props.item.cantidad"
                      @input="calcularDescuentoPorLinea($event,props.item)"
                      @keydown.up.prevent="handleKeyDown"
                      @keydown.down.prevent="handleKeyDown"
                      @mousewheel="handleKeyDown"
                    class="no-spinners"
                  ></v-text-field>
                </td>

                <div v-if="props.item.stock > 0">
                  <v-text-field
                    class="custom-label-color"
                    disabled
                    color="green"
                    type="number"
                    @keydown.up.prevent="handleKeyDown"
                    @keydown.down.prevent="handleKeyDown"
                    @mousewheel="handleKeyDown"
                    v-model="props.item.stock"
                    v-if="props.item.stock > 0"
                  ></v-text-field>
                </div>

                <div v-else>
                  <v-text-field
                    class="custom-label-color2"
                    disabled
                    color="green"
                    type="number"
                    @keydown.up.prevent="handleKeyDown"
                    @keydown.down.prevent="handleKeyDown"
                    @mousewheel="handleKeyDown"
                    v-model="props.item.stock"
                  ></v-text-field>
                </div>

                <td>
                  <v-text-field
                    type="number"
                    class="no-spinners"
                    disabled="disabled"
                    @keydown.up.prevent="handleKeyDown"
                    @keydown.down.prevent="handleKeyDown"
                    @mousewheel="handleKeyDown"
                    v-model="props.item.precio"
                  ></v-text-field>
                </td>
                <td>
                  <v-text-field
                    type="number"
                    disabled="disabled"
                    class="no-spinners"
                    @keydown.up.prevent="handleKeyDown"
                    @keydown.down.prevent="handleKeyDown"
                    @mousewheel="handleKeyDown"
                    v-model="props.item.descuento"
                  ></v-text-field>
                </td>
                <td>
                  $
                  {{
                    props.item.cantidad * props.item.precio -
                    props.item.descuento
                  }}
                </td>
              </template>
              <template slot="no-data">
                <h3>No hay artículos agregados al detalle.</h3>
              </template>
            </v-data-table>
            <v-flex class="text-xs-right">
              <strong>Subtotal: </strong>
              {{ (totalParcial = calcularTotal.toFixed(2)) | currency }}
            </v-flex>

            <v-flex class="text-xs-right">
              <strong>Envio: </strong>
              {{ calcularEnvio | currency}}
            </v-flex>
            <v-flex class="text-xs-right">
              <strong>Descuento: </strong>
              {{ calcularDescuento | currency }}
            </v-flex>
            <v-flex class="text-xs-right">
              <strong>Total Cordoba: </strong>
              {{
               calcularTotalGlobal
              }}
            </v-flex>

            <!-- <v-flex class="text-xs-right">
              <strong>Total Dólares: </strong>
              {{
               totalDolar = (
  parseFloat(calcularTotalGlobal) /
  parseFloat(tasacambio)
).toFixed(2)

              }}
            </v-flex> -->
            <v-flex v-if="esEfectivo" class="text-xs-right">
              <strong>Efectivo: </strong>

              {{ pagar | currency }}
            </v-flex>

            <v-flex  v-if="esEfectivo" class="text-xs-right">
              <strong>Cambio: </strong>

              {{
                (cambio =
                  parseFloat(pagar).toFixed(2) -
                  (
                    parseFloat(totalImpuesto) + parseFloat(totalParcial)
                  ).toFixed(2)) | currency
              }}
            </v-flex>
          </v-flex>

          <v-flex xs12 sm12 md12 lg12 xl12>
            <div
              class="red--text"
              v-for="v in validaMensaje"
              :key="v"
              v-text="v"
            ></div>
          </v-flex>
          <v-flex v-if="esEfectivo" xs12 sm4 md4 lg4 xl4>
            <v-text-field
              type="number"
              v-model="pagar"
              label="Efectivo a pagar"
            >
            </v-text-field>
          </v-flex>
          <v-flex xs12 sm12 md12 lg12 xl12>
            <v-btn @click="ocultarNuevo()" color="blue darken-1" flat
              >Cancelar</v-btn
            >
            <v-btn
              v-if="verDet == 0"
              :disabled="ocultarboton"
              @click="guardar()"
              color="success"
              >Guardar</v-btn
            >
          </v-flex>
        </v-layout>
      </v-container>
    </v-flex>
  </v-layout>
</template>
<script>
import Vue from "vue";
import {
  AutoCompletePlugin,
  AutocompletePlugin,
} from "@syncfusion/ej2-vue-dropdowns";
Vue.use(AutoCompletePlugin);
import axios from "axios";
import jsPDF from "jspdf";
import swal from "sweetalert";
import html2canvas from "html2canvas";
export default {
  data() {
    return {
      descuentoCliente: 0,
      ventas: [],
      dialog: false,
      ocultarboton: false,
      flag: false,
      checkbox: false,
      cambiarBodega: false,
      esEfectivo: false,
      esContado: false,

      headers: [
        { text: "Opciones", value: "opciones", sortable: false },
        { text: "Sucursal", value: "sucursal", sortable: false },
        { text: "No. Factura", value: "codigoFactura", sortable: false },
        { text: "Vendedor", value: "usuario", sortable: false },
        { text: "Cliente", value: "cliente", sortable: false },
        { text: "Tipo Factura", value: "tipo_comprobante", sortable: false },

        { text: "Fecha", value: "fecha_hora" },
        { text: "Tipo Envio", value: "tipoenvio" },
        { text: "Envio", value: "impuesto", sortable: false },
        { text: "Total", value: "total", sortable: false },
        { text: "Estado", value: "estado", sortable: false },
      ],
      cabeceraDetalles: [
        { text: "Borrar", value: "borrar", sortable: false },
        { text: "Artículo", value: "articulo", sortable: false },
        { text: "Cantidad", value: "cantidad", sortable: false },
        { text: "Stock Actual", value: "stock", sortable: false },
        { text: "Precio", value: "precio", sortable: false },
        { text: "Descuento", value: "descuento", sortable: false },
        { text: "Subtotal", value: "subtotal", sortable: false },
      ],
      detalles: [],
      search: "",
      id: "",
      customer: "",
      userId: "",
      isPreview: true,
      idbodega: "",
      idUsuarioContador:1028,
      nombrecliente: "",
      departamento: "",
      telefono: "",
      clientes: [],
      vendedores: [],
      bodegas: [],
      tipo_envio: "",
      num_factura: 0,      
      tipoPago:"",
      descripcionPago:"",
      tipocomprobante: "",
      comprobantes: ["CONTADO", "CREDITO"],
      tipoPagos: ["EFECTIVO", "TRANSFERENCIA"],
      envios: ["CARGOTRANS", "MOTORIZADO"],
      impuesto: 0,
      pagar: 0,
      codigo: "",
      verNuevo: 0,
      errorArticulo: null,
      totalParcial: 0,
      totalImpuesto: 0,
      total: 0,
      cambio: 0,
      tasacambio: "",
      totalDolar: 0,
      cabeceraArticulos: [
        { text: "Seleccionar", value: "seleccionar", sortable: false },
        { text: "Artículo", value: "articulo" },
        { text: "Categoría", value: "categoria" },
        { text: "Descripción", value: "descripcion", sortable: false },
        { text: "Stock", value: "stock", sortable: false },
        { text: "Precio Venta", value: "precio_venta", sortable: false },
      ],
      articulos: [],
      texto: "",
      verArticulos: 0,
      verDet: 0,
      valida: 0,
      validaMensaje: [],
      adModal: 0,
      adAccion: 0,
      adNombre: "",
      adId: "",
      adIdSucursal: "",
      comprobanteModal: 0,
      cliente: "",
      vendedor: "",
      num_documento: "",
      fecha_hora: "",
      num_factura: "",
      direccion: "",
      telefono: "",
      email: "",
    };
  },

  computed: {
    
    calcularTotal: function () {
      var resultado = 0.0;
      if(this.detalles.length > 0){
        for (var i = 0; i < this.detalles.length; i++) {
        resultado =
          resultado +
          (this.detalles[i].precio * this.detalles[i].cantidad);
        }
      }
      
      return resultado;
    },
    calcularTotalGlobal: function(){
      var resultado = 0.0;
      if(this.detalles.length > 0){
        for (var i = 0; i < this.detalles.length; i++) {
        resultado =
          resultado +
          (this.detalles[i].precio * this.detalles[i].cantidad - this.detalles[i].descuento);
        }
      }
      this.total = parseFloat(resultado) + parseFloat(this.impuesto);
      return parseFloat(resultado) + parseFloat(this.impuesto);
    },
    calcularEnvio: function () {
      var resultado = 0.0;
      resultado = this.impuesto;
      return resultado;
    },
    calcularDescuento() {
    return this.detalles.reduce((total, detalle) => {
        const descuento = detalle.descuento || 0; // Garantizar un valor por defecto
        return total + descuento; // Sumar el descuento actual al total acumulado
    }, 0); // Iniciar el acumulador en 0
},


    calcularTotalDolar: function () {
      return (
        (parseFloat(this.totalImpuesto) + parseFloat(this.totalParcial)) /
        this.tasaCambio
      );
    },
  },

  watch: {
    dialog(val) {
      val || this.close();
    },
  },

  created() {
    this.listar();
    this.select();
    this.selectUsuario();
    this.selectSucursal();
    this.idbodega = parseInt(this.$store.state.usuario.idsucursal);
    console.log();
    // if (this.$store.state.usuario.rol == "Administrador") {
      
    //   let objectInvoice = localStorage.getItem("dataInvoice");

    //   // Convertir la cadena JSON de vuelta a un objeto
    //   objectInvoice = JSON.parse(objectInvoice);

    //   // Ahora, objetoRecuperado contiene el objeto original almacenado en localStorage
    //   console.log(objectInvoice);
    //   if(objectInvoice){
    //     //Inicializar campos
    //     console.log('YEs sir')
        
    //     this.userId = parseInt(objectInvoice.idusuario);
    //     this.idbodega = parseInt(objectInvoice.idsucursal);
    //     this.customer = objectInvoice.idcliente; 
    //     this.tasacambio = objectInvoice.tasaCambio; 
    //     this.tipocomprobante = objectInvoice.tipo_comprobante;
    //     console.log(this.tasacambio)
    //   }
    // }

    if (this.$store.state.usuario.idusuario == 1022) {
      this.cambiarBodega = true;
    }
  },
  methods: {
    // calcularDescuentoPorLinea: function (event, item) {
    //     if (event && item) {
    //         if (this.descuentoCliente) {
    //             item.descuento = event * this.descuentoCliente; // Cálculo del descuento
    //             const index = this.detalles.findIndex(d => d.idarticulo === item.idarticulo);
    //             if (index !== -1) {
    //                 this.detalles.splice(index, 1, item);  // Actualiza el detalle en el arreglo
    //             }
    //             console.log('Descuento recalculado y detalle actualizado:', item);
    //         } else {
    //             console.log('Descuento del cliente no disponible');
    //         }
    //     }
    // },
    calcularDescuentoPorLinea: function (event, item) {
        if (event && item) {
            if (parseInt(this.descuentoCliente) === 0 || parseInt(this.descuentoCliente)===15) {
                item.descuento = event * this.descuentoCliente; // Cálculo del descuento
                const index = this.detalles.findIndex(d => d.idarticulo === item.idarticulo);
                if (index !== -1) {
                    this.detalles.splice(index, 1, item);  // Actualiza el detalle en el arreglo
                }
                console.log('Descuento recalculado y detalle actualizado:', item);
            } else if(parseInt(event) >= 6 && parseInt(event) <=11 ) {
              item.descuento = event * 5; // Cálculo del descuento
                const index = this.detalles.findIndex(d => d.idarticulo === item.idarticulo);
                if (index !== -1) {
                    this.detalles.splice(index, 1, item);  // Actualiza el detalle en el arreglo
                }
            }
            else if(parseInt(event) >= 12) {
              item.descuento = event * 10; // Cálculo del descuento
                const index = this.detalles.findIndex(d => d.idarticulo === item.idarticulo);
                if (index !== -1) {
                    this.detalles.splice(index, 1, item);  // Actualiza el detalle en el arreglo
                }
            }
            else{
              item.descuento = event * 0; // Cálculo del descuento
                const index = this.detalles.findIndex(d => d.idarticulo === item.idarticulo);
                if (index !== -1) {
                    this.detalles.splice(index, 1, item);  // Actualiza el detalle en el arreglo
                }
            }
        }
    },
    onChange: function (event) {
      console.log(this.selectedValue);
    },
    handleKeyDown(event) {
      event.preventDefault(); // Evitar el comportamiento por defecto de la flecha hacia arriba
    },
    validarCheck() {     
        this.tipo_envio = "";
        this.impuesto = 0;
      
    },

    clienteGenerico: function (event) {
      this.nombrecliente = "";
      this.departamento = "";
      this.telefono = "";
      if (event == 13683) {
        this.flag = true;
      } else {
        this.flag = false;
      }
      let me = this;
      me.articulos = [];
      me.articulos.pop();
      let header = { Authorization: "Bearer " + this.$store.state.token };
      let configuracion = { headers: header };
      axios
        .get(
          "api/Personas/GetClientePorId/" + event,
          configuracion
        )
        .then(function (response) {
          me.descuentoCliente = response.data.descuento;
          // me.i = response.data;
          if (me.detalles.length > 0) {
                me.detalles.forEach(detalle => {
                    // Recalcular el descuento para cada detalle basado en cantidad y el descuento del cliente
                    detalle.descuento = detalle.cantidad * me.descuentoCliente;
                });
                console.log('Descuentos recalculados:');
                console.log(me.detalles); // Muestra los detalles con los nuevos descuentos
            }
        })
        .catch(function (error) {
          console.log(error);
        });

       
    },

    // validarTipoFactura: function (event) {
    //   if(event==='CONTADO'){
    //     this.esContado = true
    //   }
    //   else{
    //     this.esEfectivo=false;
    //     this.esContado = false;
    //     this.tipoPago ="";
    //   }
    // },
    // validarFormaDePago: function (event) {
    //   if(event==='EFECTIVO'){
    //     this.esEfectivo = true;
    //     this.descripcionPago="";
    //   }
    //   else{
    //     this.esEfectivo = false;
    //     this.pagar=0;
    //   }
    // },

    redirigir() {
      // this.$router.push({ name: "login" });
      this.$store.dispatch("salir");
    },

    customSort(items, index, isDesc) {
      items.sort((a, b) => {
        if (index === "date") {
          if (!isDesc) {
            return compare(a.date, b.date);
          } else {
            return compare(b.date, a.date);
          }
        }
      });
      return items;
    },

    // imprimir() {
    //   //window.print();
    //   this.isPreview = false;
    //   var divToPrint = document.getElementById("ticket");
    //   //console.log(divToPrint);
    //   var newWin = window.open("", "Print-Window");

    //   newWin.document.open();

    //   newWin.document.write(
    //     '<html><body font color="red" face="Times New Roman" size="+1" onload="window.print()">' +
    //       divToPrint.innerHTML +
    //       "</body></html>"
    //   );

    //   newWin.document.close();

    //   setTimeout(function () {
    //     newWin.print();
    //     newWin.close();
    //   }, 1000);
    //   //setTimeout(function(){ newWin.close();},10);
    // },
//     imprimir() {
//   this.isPreview = false;

//   this.$nextTick(() => {
//     const divToPrint = document.getElementById("ticket");

//     if (divToPrint) {
//       const newWin = window.open("", "Print-Window");

//       newWin.document.open();
//       newWin.document.write(
//         `<html><head><style>body { font-family: Arial, sans-serif; }</style></head><body onload="window.print()">` +
//         divToPrint.innerHTML +
//         `</body></html>`
//       );
//       newWin.document.close();

//       setTimeout(() => {
//         newWin.print();
//         newWin.close();
//         this.isPreview = true;
//       }, 1000);
//     } else {
//       console.error("No se pudo encontrar el div con id 'ticket'.");
//     }
//   });
// },

imprimir() {
  this.isPreview = false;

  this.$nextTick(() => {
    const divToPrint = document.getElementById("ticket");

    if (divToPrint) {
      const newWin = window.open("", "Print-Window");

      const printStyles = `
        <style>
          table {
            width: 100%;
            border-collapse: collapse;
            margin-bottom: 20px;
          }

          th, td {
            border: 1px solid #ddd;
            padding: 8px;
            text-align: left;
            font-weight: bold !important;
          }

          tr {
            page-break-inside: avoid;
          }

          tfoot {
            display: table-footer-group;
          }

          tbody {
            display: table-row-group;
          }

          @media print {
            table {
              page-break-inside: auto !important;
            }

           tfoot {
            display: table-row-group !important;
            page-break-inside: avoid !important;
         }

            tr {
              page-break-inside: avoid;
            }

             tfoot {
              page-break-inside: avoid;
            }
          }
        </style>
      `;

      newWin.document.open();
      newWin.document.write(
        `<html>
          <head>${printStyles}</head>
          <body onload="window.print()">
            ${divToPrint.innerHTML}
          </body>
        </html>`
      );
      newWin.document.close();

      setTimeout(() => {
        newWin.close();
        this.isPreview = true;
      }, 1000);
    } else {
      console.error("No se pudo encontrar el div con id 'ticket'.");
    }
  });
},





    // crearPDF() {
    //   //var quotes = document.getElementById("factura");
    //   var quotes = document.getElementById("ticket-preview");
    //   html2canvas(quotes).then(function (canvas) {
    //     var imgData = canvas.toDataURL("image/png");
    //     var imgWidth = 210;
    //     //var pageHeight = 295;
    //     var pageHeight = 295;
    //     var imgHeight = (canvas.height * imgWidth) / canvas.width;
    //     var heightLeft = imgHeight;
    //     //var doc = new jsPDF("p", "mm", "a4");
    //     var doc = new jsPDF("p", "pt", "letter");
    //     var position = 0;

    //     doc.addImage(imgData, "PNG", 0, position, imgWidth, imgHeight);
    //     doc.save("FacturaVenta.pdf");
    //   });
    // },
    crearPDF() {
  var quotes = document.getElementById("ticket-preview");
  html2canvas(quotes).then(function(canvas) {
    var imgData = canvas.toDataURL('image/png');
    var imgWidth = 210; // Ancho de la página en mm (A4)
    var pageHeight = 295; // Altura de la página en mm (A4)
    var imgHeight = canvas.height * imgWidth / canvas.width;
    var heightLeft = imgHeight;

    var doc = new jsPDF('p', 'mm');
    var position = 0;

    // Primera página
    doc.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight);
    heightLeft -= pageHeight;

    // Manejo de páginas adicionales
    while (heightLeft > 0) {
      position = heightLeft - imgHeight;
      doc.addPage();
      doc.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight);
      heightLeft -= pageHeight;
    }

    // Generar el archivo PDF y descargarlo
    const fileName = `Factura_${new Date().toISOString().split('T')[0]}.pdf`;
    doc.save(fileName);

    // // Abrir WhatsApp con un mensaje preconfigurado
    // const numeroWhatsApp = "5211234567890"; // Número de WhatsApp en formato internacional
    // const mensaje = encodeURIComponent("Hola, aquí está la factura generada. Por favor, adjunta el archivo descargado.");
    // const whatsappURL = `https://wa.me/${numeroWhatsApp}?text=${mensaje}`;
    // window.open(whatsappURL, '_blank'); // Abre WhatsApp en una nueva pestaña
  });
},

    mostrarComprobante(item) {
      this.limpiar();
      console.log("Items: ", item);
      if (item.idcliente == 13683) {
        this.limpiar();
        this.tipo_comprobante = item.tipo_comprobante;
        this.num_factura = item.codigoFactura;
        this.cliente = item.nombreCliente;
        this.vendedor = item.usuario;
        this.num_documento = item.num_documento;
        this.fecha_hora = item.fecha_hora;
        this.direccion = item.departamento;
        this.telefono = item._telefono;
        this.email = item.email;
        this.impuesto = item.impuesto;
        this.tasaCambio = item.tasaCambio;
        this.listarDetalles(item.idventa);
        this.comprobanteModal = 1;
      } else {
        this.limpiar();
        this.tipo_comprobante = item.tipo_comprobante;
        this.num_factura = item.codigoFactura;
        this.cliente = item.cliente;
        this.vendedor = item.usuario;
        this.num_documento = item.num_documento;
        this.fecha_hora = item.fecha_hora;
        this.direccion = item.direccion;
        this.telefono = item.telefono;
        this.email = item.email;
        this.impuesto = item.impuesto;
        this.tasaCambio = item.tasaCambio;
        this.listarDetalles(item.idventa);
        this.comprobanteModal = 1;
      }
    },
    ocultarComprobante() {
      this.comprobanteModal = 0;
      this.isPreview = true; 
      this.limpiar();
    },
    mostrarNuevo() {
      this.verNuevo = 1;
      this.limpiar();
      if (this.$store.state.usuario.idusuario == this.idUsuarioContador) {
      
      let objectInvoice = localStorage.getItem("dataInvoice");

      // Convertir la cadena JSON de vuelta a un objeto
      objectInvoice = JSON.parse(objectInvoice);

      // Ahora, objetoRecuperado contiene el objeto original almacenado en localStorage
      console.log(objectInvoice);
      if(objectInvoice){
        //Inicializar campos
        
        this.userId = parseInt(objectInvoice.idusuario);
        this.idbodega = parseInt(objectInvoice.idsucursal);
        this.customer = objectInvoice.idcliente; 
        this.tasacambio = objectInvoice.tasaCambio; 
        this.tipocomprobante = objectInvoice.tipo_comprobante;
        console.log(this.tasacambio)
      }
    }
    },
    ocultarNuevo() {
      this.verNuevo = 0;
      this.flag = false;
      this.limpiar();
    },
    buscarCodigo() {
      if (!this.idbodega) {
        swal({
          title: "Debe de seleccionar la sucursal origen",
          // text:"Debe de seleccionar la sucursal origen",
          icon: "warning",
          timer: 2000,
        });
        this.codigo = "";
        return;
      }

      let me = this;
      me.errorArticulo = null;
      let header = { Authorization: "Bearer " + this.$store.state.token };
      let configuracion = { headers: header };
      axios
        .get(
          "api/Articulos/BuscarCodigoVenta/" + this.codigo + "/" + me.idbodega,
          configuracion
        )
        .then(function (response) {
          //console.log(response);
          //   this.codigo = "";
          me.codigo = "";
          me.agregarDetalle(response.data);
        })
        .catch(function (error) {
          console.log(error);
          me.errorArticulo = "No existe el artículo";
        });
    },
    listarArticulo() {
      let me = this;
      me.articulos = [];
      me.articulos.pop();
      let header = { Authorization: "Bearer " + this.$store.state.token };
      let configuracion = { headers: header };
      axios
        .get(
          "api/Articulos/ListarVenta/" + me.texto + "/" + me.idbodega,
          configuracion
        )
        .then(function (response) {
          //console.log(response);
          me.articulos = response.data;
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    mostrarArticulos() {
      this.verArticulos = 1;
    },
    ocultarArticulos() {
      this.articulos = [];
      this.articulos.pop();
      this.texto = "";
      this.verArticulos = 0;
    },
    agregarDetalle(data = []) {

      this.errorArticulo = null;
      if(!this.customer){
        this.errorArticulo = "Debe de selecionar el cliente";
        swal(
              "Error al realizar venta",
              "Debe de selecionar el cliente para poder agregar un articulo",
              "warning"
            );
        return
      }
      if (this.encuentra(data["idarticulo"])) {
        this.errorArticulo = "El artículo ya ha sido agregado.";
      } else {
        this.texto = "";
        this.detalles.push({
          idarticulo: data["idarticulo"],
          articulo: data["nombre"],
          cantidad: 1,
          precio: data["precio_venta"],
          stock: data["stock"],
          descuento: this.descuentoCliente,
        });
      }
    },
    encuentra(id) {
      var sw = 0;
      for (var i = 0; i < this.detalles.length; i++) {
        if (this.detalles[i].idarticulo == id) {
          sw = 1;
        }
      }
      return sw;
    },
    eliminarDetalle(arr, item) {
      var i = arr.indexOf(item);
      if (i !== -1) {
        arr.splice(i, 1);
      }
    },

    listar() {
      var dias = 90;
      var TuFecha = new Date();
      var resultado;

      //dias a sumar
      var dias = parseInt(dias);

      //nueva fecha sumada
      TuFecha.setDate(TuFecha.getDate() + dias);

      resultado = TuFecha.getDay();

      var fecha;

      let me = this;
      let header = { Authorization: "Bearer " + this.$store.state.token };
      let configuracion = { headers: header };
      let url = "";
      url = "api/Ventas/Listar";

      axios
        .get(url, configuracion)
        .then(function (response) {
          me.ventas = response.data;
        })
        .catch(function (error) {
          if (error.response.status == "401") {
            swal(
              "Sesión caducada",
              "Su sesión ha expirado favor volver a iniciar sesión",
              "warning"
            );
            me.redirigir();
          }
        });
    },
    listarDetalles(id) {
      let me = this;
      let header = { Authorization: "Bearer " + this.$store.state.token };
      let configuracion = { headers: header };
      axios
        .get("api/Ventas/ListarDetalles/" + id, configuracion)
        .then(function (response) {
          //console.log(response);
          me.detalles = response.data;
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    verDetalles(item) {
      this.limpiar();
      this.tipocomprobante = item.tipo_comprobante;
      this.customer = item.idcliente;
      this.userId = item.idusuario;
      this.impuesto = item.impuesto;
      this.cambio = item.cambio;
      this.pagar = item.pagar;
      this.tasacambio= item.tasaCambio;
      this.tipoPago= item.tipoPago;
      this.descripcionPago= item.descripcionPago;
      this.listarDetalles(item.idventa);
      // this.validarTipoFactura(item.tipo_comprobante);
      // this.validarFormaDePago(item.tipoPago);
      this.verNuevo = 1;
      this.verDet = 1;
    },
    select() {
      let me = this;
      var clientesArray = [];
      let header = { Authorization: "Bearer " + this.$store.state.token };
      let configuracion = { headers: header };
      axios
        .get("api/Personas/SelectClientes", configuracion)
        .then(function (response) {
          clientesArray = response.data;
          // console.log(clientesArray);
          clientesArray.map(function (x) {
            me.clientes.push({ text: x.nombre, value: x.idpersona });
          });
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    selectUsuario() {
      let me = this;
      var usuariosArray = [];
      let header = { Authorization: "Bearer " + this.$store.state.token };
      let configuracion = { headers: header };
      axios
        .get("api/Usuarios/Select", configuracion)
        .then(function (response) {
          usuariosArray = response.data;
          usuariosArray.map(function (x) {
            me.vendedores.push({ text: x.nombre, value: x.idusuario });
          });
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    selectSucursal() {
      let me = this;
      var BodegasArray = [];
      let header = { Authorization: "Bearer " + this.$store.state.token };
      let configuracion = { headers: header };
      axios
        .get("api/Articulos/Sucursal", configuracion)
        .then(function (response) {
          BodegasArray = response.data;
          console.log("Bodegas", BodegasArray);
          BodegasArray.map(function (x) {
            me.bodegas.push({ text: x.name, value: x.id });
          });
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    limpiar() {
      this.id = "";
      // this.idcliente = "";
      // this.idusuario = "";
      // this.tipo_comprobante = "";
      this.customer="";
      this.userId="";
      this.tipocomprobante="";
      this.impuesto = 0;
      this.codigo = "";
      this.detalles = [];
      this.validaMensaje = [];
      this.total = 0;
      this.pagar = 0;
      this.cambio = 0;
      this.totalImpuesto = 0;
      this.totalParcial = 0;
      this.verDet = 0;
      this.texto = "";
      this.nombrecliente = "";
      this.departamento = "";
      this.telefono = "";
      this.tipo_envio = "";
      this.checkbox = false;
      this.tasacambio = 36.62;
    },
    guardar() {
      if (this.validar()) {
        return;
      }
      //$("button").prop("disabled", false);
      let header = { Authorization: "Bearer " + this.$store.state.token };
      let configuracion = { headers: header };
      let me = this;
      me.ocultarboton = true;
      // Agregar el campo lineNum y asignar valores incrementales
      me.detalles.forEach((detalle, index) => {
        detalle.lineNum = index + 1;
      });

      let localStorage = {
        idusuario: me.userId,
        idcliente: me.customer,
        idsucursal: me.idbodega,
        tipo_comprobante: me.tipocomprobante,
        tasaCambio: me.tasacambio
      };
      let obj = {
        idcliente: me.idcliente,
        idusuario: me.idusuario,
        //idusuario: me.$store.state.usuario.idusuario,
        idsucursal: me.idbodega,
        tipo_comprobante: me.tipo_comprobante,
        impuesto: me.impuesto,
        total: me.calcularTotalGlobal,
        tipoEnvio: me.tipo_envio,
        nombrecliente: me.nombrecliente,
        departamento: me.departamento,
        _telefono: me.telefono,
        detalles: me.detalles,
      };
      //Guardar data en localStorage
      this.$store.dispatch("saveDataInvoice", JSON.stringify(localStorage));
      // this.$store.dispatch("saveDataInvoice", localStorage);

      axios
        .post(
          "api/Ventas/Crear",
          {
            idcliente: me.customer,
            idusuario: me.userId,
            //idusuario: me.$store.state.usuario.idusuario,
            idsucursal: me.idbodega,
            tipo_comprobante: me.tipocomprobante,
            impuesto: me.impuesto,
            total: me.calcularTotalGlobal,
            nombrecliente: me.nombrecliente,
            _telefono: me.telefono,
            departamento: me.departamento,
            tipoEnvio: me.tipo_envio,
            totalDolar: me.totalDolar,
            tasaCambio: me.tasacambio,
            // tipoPago: me.tipoPago,
            tipoPago: "EFECTIVO",
            descripcionPago: me.descripcionPago,
            detalles: me.detalles,
          },
          configuracion
        )

        .then(function (response) {
          console.log(response.data);
          console.log(response.data.id_Venta);
          // me.listarDetalles(response.data.id_Venta);
          // me.mostrarComprobante(me.detalles)
          swal(
            "Venta realizada",
            `La venta se ha realizado correctamente \n No. Factura ${response.data.codigoFactura} `,
            "success"
            //this.listarDetalles(response.data)
          );

          //alert(response);
          me.ocultarboton = false;
          me.ocultarNuevo();
          me.listar();
          me.limpiar();
        })
        .catch(function (error) {
          console.log(error)
          console.log("{{Error}}", error.response.data);
          console.log("{{Message}}", error.response.data.message);
          if (error.response.data.ok) {
            swal(
              "Error al realizar venta",
              error.response.data.message,
              "error"
            );
          } else {
            swal(
              "Error al realizar venta",
              "La venta no se ha realizado correctamente",
              "error"
            );
          }
          //   alert(error);

          me.ocultarboton = false;
        });
    },
    validar() {
      this.valida = 0;
      this.validaMensaje = [];
    //   if (this.tipocomprobante == "CONTADO") {
    //   if (!this.tipoPago) {
    //     this.validaMensaje.push("Seleccione el tipo de pago.");
    //   }
    // }

      // if (this.tipocomprobante == "CONTADO" && this.tipoPago==='EFECTIVO') {
      //   if (this.pagar <= 0 || this.pagar == undefined) {
      //     this.validaMensaje.push("Ingrese un monto a pagar válido");
      //   }
      //   if (
      //     parseFloat(parseFloat(this.pagar).toFixed(2)) <
      //     parseFloat(parseFloat(this.total).toFixed(2))
      //   ) {
      //     this.validaMensaje.push(
      //       "El precio a pagar no puede ser menor al total neto"
      //     );
      //   }

      //   const isEmpty = (value) => value == null || value.trim() === '';

      // if (this.tipoPago === 'TRANSFERENCIA' && isEmpty(this.descripcionPago)) {
      //     console.error('Error: La descripción del pago es obligatoria cuando el tipo de pago es TRANSFERENCIA.');
      // }
      // }
    // if(this.tipoPago==='TRANSFERENCIA' && (this.descripcionPago == null || this.descripcionPago == undefined || this.descripcionPago==='' )){
    //   this.validaMensaje.push("Campo de numero de referencia requerido");
    //   swal("", "Campo de numero de referencia requerido", "error");
    // }

      if (this.checkbox) {
        if (this.tipo_envio == "") {
          this.validaMensaje.push("Campos de envio requeridos");
          swal("", "Campos de envio requeridos", "error");
        }
        if (parseFloat(this.impuesto) <= 0 || !this.impuesto) {
          this.validaMensaje.push("El campo de envio inválido");
          swal("", "El campo de envio inválido", "error");
        }
      }

      if (this.tasacambio == "" || parseFloat(this.tasacambio) <= 0) {
        this.validaMensaje.push("La tasa de cambio es un campo requerido");
      }

      if (!this.customer) {
        this.validaMensaje.push("Seleccione un cliente.");
      }
      const clientesEspeciales = [13683, 13744, 13745];
      if (clientesEspeciales.includes(this.customer) && this.tipocomprobante == "CREDITO") {
        this.validaMensaje.push("Seleccione un cliente válido para Credito");
        swal(
          "Cliente de crédito no válido",
          "El cliente de crédito que selecciono debe de tener un nombre válido",
          "error"
        );
      }

      if (this.customer === 13683) {
        if (
          this.nombrecliente == "" ||
          this.departamento == "" ||
          this.telefono == ""
        ) {
          this.validaMensaje.push("Todos campos del cliente son requeridos");
          swal(
            "Campos no completados",
            "Los campos del cliente son requeridos",
            "error"
          );
        }
      }
      if (
        (this.customer == 13683 && this.telefono.length < 8) ||
        this.telefono.length > 10
      ) {
        this.validaMensaje.push(
          "El campo telefono es incorrecto minimo 8 caracteres"
        );
        swal(
          "Campos no completados",
          "El campo telefono es incorrecto minimo 8 caracteres",
          "error"
        );
      }

      if (!this.userId) {
        this.validaMensaje.push("Seleccione un vendedor.");
      }
      if (!this.tipocomprobante) {
        this.validaMensaje.push("Seleccione un tipo de factura.");
      }
      /*if (!this.num_comprobante) {
        this.validaMensaje.push("Ingrese el número del comprobante.");
      }*/
      if (this.impuesto < 0) {
        this.validaMensaje.push("Ingrese un envio válido.");
      }
      if (this.cantidad <= 0) {
        this.validaMensaje.push("Ingrese una cantidad válida.");
      }

      if (this.cantidad > this.stock) {
        this.validaMensaje.push("No hay suficiente stock para la venta.");
      }

      if (this.detalles.cantidad <= 0) {
        this.validaMensaje.push(".");
      }

      /* if (this.cantidad > cantidad) {
        this.validaMensaje.push("No se hay sufiente stock en el articulo.");
      }*/

      if (this.detalles.length <= 0) {
        this.validaMensaje.push("Ingrese al menos un artículo al detalle.");
      }
      if (this.validaMensaje.length) {
        this.valida = 1;
      }
      return this.valida;
    },
    activarDesactivarMostrar(accion, item) {
      console.log("Anular: ", item);
      this.adModal = 1;
      this.adNombre = item.num_comprobante;
      this.adId = item.idventa;
      this.adIdSucursal = item.idsucursal;
      if (accion == 1) {
        this.adAccion = 1;
      } else if (accion == 2) {
        this.adAccion = 2;
      } else {
        this.adModal = 0;
      }
    },
    activarDesactivarCerrar() {
      this.adModal = 0;
    },

    desactivar() {
      let me = this;
      let header = { Authorization: "Bearer " + this.$store.state.token };
      let configuracion = { headers: header };
      axios
        .put(
          "api/Ventas/Anular/" + this.adId + "/" + this.adIdSucursal,
          {},
          configuracion
        )
        .then(function (response) {
          me.adModal = 0;
          me.adAccion = 0;
          me.adNombre = "";
          me.adId = "";
          me.listar();
        })
        .catch(function (error) {
          console.log(error);
        });
    },
  },
};
</script>

<style>
@import url(https://cdn.syncfusion.com/ej2/material.css);
#logo {
  margin: 0 auto;
}
#imagen {
  width: 10px;
  margin-top: 0px;
  margin-bottom: 0px;
}

td.producto,
th.producto {
  width: 60px;
  text-align: center;
  max-width: 40px;
  font-size: 8px;
  font-family: "Times New Roman";
  word-break: break-all;
}

td.cantidad,
th.cantidad {
  text-align: center;
  width: 40px;
  max-width: 60px;
  word-break: normal;
  font-size: 8px;
  font-family: "Times New Roman";
}

td.precio,
th.precio {
  width: 60px;
  margin-left: 200px;
  max-width: 40px;
  font-size: 8px;
  text-align: center;
  font-family: "Times New Roman";
  word-break: break-all;
}

#centrado {
  text-align: center;
  align-content: center;
  font-weight: bold;
}

.centrado {
  text-align: center;
  align-content: center;
  font-weight: bold;
}

.texto {
  text-align: center;
  align-content: center;
  margin: auto;
  font-family: Arial, Helvetica, sans-serif;
  font-size: 20px;
}

#ticket {
  width: 255px;
  max-width: 255px;
  font-size: 10px;
  text-align: center;
  font-family: Arial, sans-serif;
  margin-left: 40px;
}

.no-spinners input::-webkit-outer-spin-button,
.no-spinners input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

.no-spinners input[type="number"] {
  -moz-appearance: textfield;
}
.okas {
  border-top-style: dotted;
}
img {
  max-width: inherit;
  width: inherit;
}
table {
    width: 100% !important;
    border-collapse: collapse !important;
    margin-bottom: 20px !important;
  }

  th, td {
    border: 1px solid #ddd !important;
    padding: 8px !important;
    text-align: left !important;
  }

  tr {
    page-break-inside: avoid !important; /* Evita que las filas se dividan entre páginas */
  }

  /* Pie de la tabla */
  tfoot {
    display: table-footer-group !important; /* Esto asegura que solo se muestre al final */
  }

  tbody {
    display: table-row-group !important;
  }


@media print {
  /* Evitar que los encabezados se repitan */
  thead {
      display: table-header-group !important;
    }

    /* Solo mostrar el pie de página al final */
    tfoot {
            display: table-row-group !important;
            page-break-inside: avoid !important;
         }

    /* Evitar que las filas se dividan entre páginas */
    tr {
      page-break-inside: avoid !important;
    }


    /* Añadir espacio al final de la última página para evitar corte abrupto */
    @page {
      size: auto !important;
      margin: 10mm !important;
    }

  }


/* preview */
.ticket-preview {
  /* Cambios específicos para la vista previa */
  width: 100%;
  max-width: none;
  font-size: 14px;
  text-align: left;
  margin: 20px auto;
  padding: 20px;
  background-color: #f9f9f9;
  box-shadow: 0px 2px 6px rgba(0, 0, 0, 0.1);
}

.ticket-preview img {
  width: 80px;
  display: block;
  margin: 10px auto;
}

.ticket-preview table {
  width: 100%;
  margin: 20px 0;
  border-collapse: collapse;
}

.ticket-preview th,
.ticket-preview td {
  text-align: center;
  padding: 5px;
  border: 1px solid #ddd;
}

.ticket-preview .centrado {
  text-align: center;
  font-weight: bold;
}


</style>
